import axios, { AxiosResponse } from "axios";
import CourseNoteCategoryView from "../../models/views/education/CourseNoteCategoryView";
import BaseService from "../base/BaseService";

export default class CourseNoteCategoryService extends BaseService {
    getByCourseId(courseId: number): Promise<CourseNoteCategoryView[]> {
        return axios.get(`/CourseNoteCategory/Student`, {
            params: { CourseId: courseId }
        }).then(function (response: AxiosResponse<CourseNoteCategoryView[], any>) {
            return response.data;
        });
    }
}
